import React from 'react';

const CGU: React.FC = () => {
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
            Conditions Générales d'Utilisation
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            En vigueur au 11/07/2025
          </p>
        </div>

        <div className="mt-12 space-y-12 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">1. Objet</h2>
            <p className="mt-2">
              Les présentes Conditions Générales d'Utilisation ("CGU") définissent les modalités d’accès et d’usage du site api100.io, édité par Global Gestion Sàrl.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">2. Éditeur du site</h2>
            <p className="mt-2">
              api100.io est édité par :<br />
              Global Gestion Sàrl<br />
              Route de Collex 22D, 1294 Genthod, Suisse<br />
              ✉️ <a href="mailto:contact@api100.io" className="text-blue-600 hover:underline">contact@api100.io</a><br />
              ☎️ +41 58 332 23 70
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">3. Accès au service</h2>
            <p className="mt-2">
              Le service est accessible à tout utilisateur disposant de la pleine capacité juridique. L’accès est gratuit pour certaines offres et payant pour d’autres, selon les modalités précisées dans les CGV.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">4. Inscription</h2>
            <p className="mt-2">
              Pour accéder au service, l’utilisateur doit créer un compte et fournir des informations exactes et à jour. Un seul compte est autorisé par utilisateur.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">5. Fonctionnalités</h2>
            <ul className="list-disc list-inside mt-2">
              <li>Connexion sécurisée d’API locales via tunnel WebSocket</li>
              <li>Statistiques anonymisées</li>
              <li>Accès à l’API Sage 100 pour les comptes Business</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">6. Obligations de l’utilisateur</h2>
            <ul className="list-disc list-inside mt-2">
              <li>Utiliser le service de manière conforme aux lois suisses</li>
              <li>Ne pas compromettre la sécurité du système</li>
              <li>Respecter les limitations techniques prévues par l’abonnement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">7. Propriété intellectuelle</h2>
            <p className="mt-2">
              Tous les éléments du site (code, marques, textes, etc.) sont la propriété exclusive de Global Gestion Sàrl. Toute reproduction est interdite sans autorisation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">8. Données</h2>
            <p className="mt-2">
              Aucune donnée de contenu n’est stockée. Seules des statistiques techniques anonymisées sont collectées. Voir notre <a href="/privacy-policy" className="text-blue-600 hover:underline">Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">9. Modification</h2>
            <p className="mt-2">
              Global Gestion Sàrl se réserve le droit de modifier les présentes CGU à tout moment. L’utilisateur sera informé par email ou via l’interface du site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">10. Droit applicable</h2>
            <p className="mt-2">
              Les présentes CGU sont régies par le droit suisse. Tout litige sera porté devant les tribunaux du canton de Genève.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGU;
